import { render, staticRenderFns } from "./SignDocument.vue?vue&type=template&id=dabda264"
import script from "./SignDocument.vue?vue&type=script&lang=ts"
export * from "./SignDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports